import { useState } from "react";
import { useLenis } from "../hooks/useLenis";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import TrustStrip from "../components/site/TrustStrip";
import EditorialMarquee from "../components/site/EditorialMarquee";
import WhyChooseUs from "../components/site/WhyChooseUs";
import WhoWeHelp from "../components/site/WhoWeHelp";
import Expertise from "../components/site/Expertise";
import Services from "../components/site/Services";
import Process from "../components/site/Process";
import Categories from "../components/site/Categories";
import FaqSection from "../components/site/FaqSection";
import CTABand from "../components/site/CTABand";
import Footer from "../components/site/Footer";
import ContactDialog from "../components/site/ContactDialog";

export default function Landing() {
  const [contactOpen, setContactOpen] = useState(false);
  useLenis();

  const openContact = () => setContactOpen(true);

  return (
    <main data-testid="landing-page" className="bg-ivory text-charcoal font-body overflow-x-clip">
      <Nav onContact={openContact} />
      <Hero onContact={openContact} />
      <TrustStrip />
      <EditorialMarquee />
      <WhyChooseUs />
      <WhoWeHelp />
      <Expertise />
      <Services />
      <Process />
      <Categories />
      <FaqSection />
      <CTABand onContact={openContact} />
      <Footer />
      <ContactDialog open={contactOpen} onOpenChange={setContactOpen} />
    </main>
  );
}
